/**
 * @fileoverview POST handler for the "/custom_objects/:type_name/:external_id/users" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameExternalIdUsers } from "./constants";
import type {
  PostCustomObjectsTypeNameExternalIdUsersParams,
  PostCustomObjectsTypeNameExternalIdUsersResponse,
} from "./types";

export const postCustomObjectsTypeNameExternalIdUsers = reactQueryMutationAdapter(
  customObjectsTypeNameExternalIdUsers,
  ({
    appGroupId,
    typeName,
    externalId,
    users,
  }: PostCustomObjectsTypeNameExternalIdUsersParams): Promise<PostCustomObjectsTypeNameExternalIdUsersResponse> => {
    return fetch<PostCustomObjectsTypeNameExternalIdUsersResponse>(
      `/custom_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(externalId)}/users`,
      "POST",
      { app_group_id: appGroupId, users },
      {},
      { propagateFetchRequestError: false }
    );
  }
);
